/**
 * Colour-scheme preference keys (TMMPDM-0039). A UI preference, never a credential: MUI's
 * `ThemeProvider` persists the chosen mode (`light` | `dark` | `system`) in `localStorage` under
 * `COLOR_SCHEME_MODE_KEY`. `COLOR_SCHEME_RESOLVED_KEY` is the prefix MUI reads for a named
 * per-mode scheme (`…-light` / `…-dark`); it writes them only through `setColorScheme`, which this
 * app never calls — set so that no `mui-*` default key is ever read or written. Both are
 * allowlisted by `src/storage.guard.test.ts`, and `public/color-scheme-init.js` reads the mode
 * key before the bundle loads so the first paint uses the saved scheme.
 */
export const COLOR_SCHEME_MODE_KEY = 'tmm_product_admin.colorScheme';
export const COLOR_SCHEME_RESOLVED_KEY = 'tmm_product_admin.colorSchemeResolved';

export const COLOR_SCHEME_MODES = ['light', 'dark', 'system'] as const;
export type ColorSchemeMode = (typeof COLOR_SCHEME_MODES)[number];
